import {
  UPDATEORADDCUSTOMERBANKDETAILS_SUCCESS,
  UPDATEORADDCUSTOMERBANKDETAILS_FAILED,
  RESET_UPDATEORADDCUSTOMERBANKDETAILS,
  LOADING_UPDATEORADDCUSTOMERBANKDETAILS,
  NETWORK_ERROR_UPDATEORADDCUSTOMERBANKDETAILS,
} from "../types/index";


const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_UPDATEORADDCUSTOMERBANKDETAILS:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case UPDATEORADDCUSTOMERBANKDETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case UPDATEORADDCUSTOMERBANKDETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_UPDATEORADDCUSTOMERBANKDETAILS:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_UPDATEORADDCUSTOMERBANKDETAILS:
      return (state = initialState);
    default:
      return state;
  }
};
